module.exports = __webpack_public_path__ + "static/media/coursio-logotype.955dd07b.svg";